import {
  Button, Card, Col, Row, Typography,
} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { EditOutlined } from '@ant-design/icons';
import Droppable from './Droppable';
import Draggable from './Draggable';

const TicketsColumn = ({
  id,
  title,
  activeDraggableTicket = null,
  tickets,
  onEditTicket,
}) => (
  <Card
    title={title}
    variant="outlined"
    styles={{
      body: { padding: 0 },
      header: { textAlign: 'center', minHeight: 'unset' },
    }}
  >
    <Droppable id={id}>
      {tickets.map((ticket) => (ticket.id === activeDraggableTicket?.id ? null : (
        <Draggable
          key={ticket.id}
          id={ticket.id}
          title={ticket.title}
          authorName={ticket.authorName}
          authorId={ticket.authorId}
        >
          <Card
            title={(
              <Row>
                <Col span={10} style={{ textWrap: 'wrap' }}>{ticket.title}</Col>
                <Col span={10} style={{ textAlign: 'right' }}>
                  <Typography.Text style={{ fontWeight: 'normal' }} type="secondary">
                    {ticket.authorName}
                  </Typography.Text>
                </Col>
                <Col span={4} style={{ textAlign: 'right' }}>
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => onEditTicket(ticket)}
                  />
                </Col>
              </Row>
            )}
          >
            {ticket.description}
          </Card>
        </Draggable>
      )))}
    </Droppable>
  </Card>
);

TicketsColumn.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  activeDraggableTicket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    authorId: PropTypes.number.isRequired,
    authorName: PropTypes.string.isRequired,
  }),
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    authorId: PropTypes.number.isRequired,
    authorName: PropTypes.string.isRequired,
  })).isRequired,
  onEditTicket: PropTypes.func.isRequired,
};

export default TicketsColumn;
